import produce from 'immer'
import { actionTypes } from '../actions/accountActions'
const initialState = {}

const AccountReducer = (state = initialState, action) =>
    produce(state, draft => {
        switch (action.type) {
            case actionTypes.GET_PROFILE_SUCCESS: {
                draft.user = action.payload
                draft.user.userAddresses = JSON.parse(draft.user.userAddresses || '[]')
                break
            }
            case actionTypes.UPDATE_PROFILE_SUCCESS: {
                const { payload } = action
                draft.user = {
                    ...draft.user,
                    ...payload,
                    userPassword: ''
                }
                break
            }
            case actionTypes.UPDATE_ADDRESS_SUCCESS: {
                draft.user.userAddresses = action.payload
                break
            }
            case actionTypes.LOGOUT: {
                draft.user = null
                break
            }
            default:
                return state
        }
    })

export default AccountReducer
